function Menu() {
	this.build();
}

Menu.prototype.build = function () {
	const headerOpen = $('.header-open');
	$('.menu-button').on('click', function () {
		headerOpen.addClass('open');
	});
	$('.cross').on('click', function () {
		headerOpen.removeClass('open');
	});
};
